module.exports = __webpack_public_path__ + "img/56.29e04402.jpg";